import React from 'react';

const ExperienceCard = ({img, company, job, mission, date}) => {
    return (
        <div className="experience-card">
            <div className="experience-img">
                {img ? (
                    <img src={img} alt={`Logo ${company}`}/>
                ) : (
                    <div className="experience-img-placeholder">BIR</div>
                )}
            </div>
            <div className="experience-card-heading">
                {company && <p className="experience-company">{company}</p>}
                <p className="experience-job">{job}</p>
            </div>
            <div className="experience-card-mission">
                <span>Mission //</span>
                <p>{mission}</p>
            </div>
            <div className="experience-card-date">
                {date}
            </div>
        </div>
    );
};

export default ExperienceCard;
